import React from "react";
// import styles from "../../../CSS/ui/card/IconTitleContent.module.css";

const IconTitleContent = ({
  content,
  cardStyle = {},
  textColor = "text-light",
  iconStyles = {},
  iconDescriptionStyles = {}
}) => {
  const { icon, title, description } = content;
  return (
    <div style={cardStyle}>
      <img src={icon} alt={title} className="mb-4" style={iconStyles} />
      <h3
        className={`${iconDescriptionStyles.heading3} ${textColor} font-semibold`}
        style={{ marginBottom: "12px" }}
      >
        {title}:
      </h3>
      <p className={`p16 ${iconDescriptionStyles.iconDescription} ${textColor} font-semibold mb-0`}>{description}</p>
    </div>
  );
};

export default IconTitleContent;
